export const LegalPage = ({ title, updated, sections, testId }) => (
  <div data-testid={testId} className="pt-20 min-h-screen bg-[#F8F5F0]">
    <div className="max-w-[760px] mx-auto px-6 py-24 sm:py-28">
      <p className="text-xs uppercase tracking-[0.3em] text-[#C6A769] mb-6 text-center">Legal</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl text-[#4A3F35] mb-4 text-center">{title}</h1>
      <p className="text-xs uppercase tracking-[0.2em] text-[#4A3F35]/50 text-center mb-6">
        Last updated: {updated}
      </p>
      <div className="w-16 h-px bg-[#C6A769] mx-auto mb-14" />
      <div className="space-y-12">
        {sections.map((s, i) => (
          <section key={i}>
            {s.label && (
              <h2 className="text-xs uppercase tracking-[0.25em] text-[#C6A769] mb-4">{s.label}</h2>
            )}
            {s.paragraphs.map((p, j) => (
              <p key={j} className="text-[15px] text-[#4A3F35]/70 leading-relaxed mb-4 last:mb-0">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </div>
  </div>
);
